module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/startpage_de-a84d19508582be6e75dea13815e7c3ed.gif";